import Partnership16 from '@carbon/icons-react/es/partnership/16';
import Person16 from '@carbon/icons-react/es/person/16';
import { Tooltip } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { UserType } from 'api/models';
import { Avatar } from 'components/atoms/avatar';
import { DemandRole } from 'components/organisms/resource-management/resource-types';
import { NameCell } from 'components/organisms/timesheets/common/cells/name-cell';
import { ProductiveHeading07 } from 'components/styles';
import { CellWrapper, TextWrapperWithEllipsis } from './component';

interface Props
  extends Pick<
    DemandRole,
    'roleId' | 'roleName' | 'userCount' | 'userCountByUserType'
  > {
  onWrapperClick: () => void;
  showPartnerUserCount: boolean;
}

const NameCellContent = styled.div`
  display: flex;
  justify-content: space-between;
`;

const NameWrapper = styled(TextWrapperWithEllipsis)`
  ${ProductiveHeading07};
  padding-right: var(--spacing-04);
`;

const NativeUserCount = styled.div`
  display: flex;
  align-items: center;
`;
const PartnerUserCount = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-02);
`;

const UserCounts = styled.div`
  display: flex;
  align-items: center;
  color: var(--gray-50);
  gap: var(--spacing-05);
`;

export const DemandRoleCell: FC<Props> = ({
  onWrapperClick,
  roleName,
  userCountByUserType,
  showPartnerUserCount,
}) => {
  return (
    <CellWrapper onClick={onWrapperClick}>
      <NameCell
        logo={<Avatar name={roleName} />}
        primaryText={
          <NameCellContent>
            <NameWrapper>{roleName}</NameWrapper>
            <UserCounts>
              <Tooltip title={<FormattedMessage id="your_team_members" />}>
                <NativeUserCount>
                  {userCountByUserType[UserType.Native] ?? 0} <Person16 />
                </NativeUserCount>
              </Tooltip>
              {showPartnerUserCount ? (
                <Tooltip title={<FormattedMessage id="partner_team_members" />}>
                  <PartnerUserCount>
                    {userCountByUserType[UserType.Partner] ?? 0}
                    <Partnership16 />
                  </PartnerUserCount>
                </Tooltip>
              ) : null}
            </UserCounts>
          </NameCellContent>
        }
      />
    </CellWrapper>
  );
};
